export default __webpack_public_path__ + "static/media/support_platform_mall4.fca85f02.png";